module.exports = __webpack_public_path__ + "static/media/A TRIAL 1-if-correct.4b8ad031.mp3";